// extracted by mini-css-extract-plugin
module.exports = {"title":"AcademyHeroV2_title__vGZL4","backgroundImg":"AcademyHeroV2_backgroundImg__iZA5n","slide-out-fwd-tr":"AcademyHeroV2_slide-out-fwd-tr__WwRtR"};